import React from "react";
import "./sign-in.scss";
import { Link, useNavigate } from "react-router-dom";

// components
import LoginButton from "../login-button/login-button";

// firebase
import { signInWithGoogle } from "../../utils/firebase.auth.utils";
import { useTranslation } from "react-i18next";
import { getAdditionalUserInfo } from "firebase/auth";
import { setCuratedOnboardingPending } from "../../utils/curated-stack.utils";

interface ISignIn {
  handleEmailClick: () => void;
}

const SignIn = ({ handleEmailClick }: ISignIn) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    const result = await signInWithGoogle();
    if (!result) return;

    const additionalUserInfo = getAdditionalUserInfo(result);
    if (additionalUserInfo?.isNewUser) {
      setCuratedOnboardingPending();
      navigate("/curated-stack", { replace: true });
    }
  };

  return (
    <div className="sign-in">
      <h2>{t('signIn.Swipe rings')}</h2>
      <span>{t('signIn.And find your perfect match')}</span>
      <div className="buttons">
        <LoginButton onClick={handleGoogleSignIn} isGoogleSignIn>
        {t('signIn.Sign in with Google')}
        </LoginButton>
        <LoginButton onClick={() => handleEmailClick()}>{t('signIn.Sign in with email')}</LoginButton>
      </div>
      <span className="smaller">
      {t('signIn.By creating or signing into your account you agree to our')} <Link to="/terms">{t('signIn.terms')}</Link>
      </span>
    </div>
  );
};

export default SignIn;
